var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeaturedPin = function SvgFeaturedPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dbc598",
    d: "M39.645 15.575L29.765 24l2.96 12.5c.206.879-.753 1.563-1.475 1.101L20 30.964 8.75 37.601c-.722.461-1.678-.223-1.473-1.101L10.238 24 .356 15.572a.997.997 0 0 1 .585-1.767l13.026-1.055L19.055.868c.352-.824 1.537-.824 1.89 0l5.088 11.882 13.027 1.056a.998.998 0 0 1 .585 1.769"
  })));
};
export default SvgFeaturedPin;